import { render } from "./BaseCarouselCenter.vue?vue&type=template&id=0af72416&scoped=true"
import script from "./BaseCarouselCenter.vue?vue&type=script&lang=js"
export * from "./BaseCarouselCenter.vue?vue&type=script&lang=js"

import "./BaseCarouselCenter.vue?vue&type=style&index=0&id=0af72416&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af72416"]])

export default __exports__